import type { BaseActionType } from '@essent/common';
import { filter } from 'rxjs/operators';

export function ofActionId<A>(actionId: string) {
  return filter((action: BaseActionType<A>) => action.actionId === actionId);
}
